import { render } from "./Handicap.vue?vue&type=template&id=2aa7ff85"
import script from "./Handicap.vue?vue&type=script&lang=js"
export * from "./Handicap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/private/messages/Handicap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2aa7ff85"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2aa7ff85', __exports__)) {
    api.reload('2aa7ff85', __exports__)
  }
  
  module.hot.accept("./Handicap.vue?vue&type=template&id=2aa7ff85", () => {
    api.rerender('2aa7ff85', render)
  })

}


export default __exports__